// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Check_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.53 7.28-12 12a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 0 1 1.06-1.06L9 17.69 20.47 6.22a.75.75 0 0 1 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'Check_Stroke2_Corner0_Rounded',
})

export const CheckThick_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.796 7.546-12 12a1.125 1.125 0 0 1-1.594 0l-5.25-5.25a1.127 1.127 0 1 1 1.594-1.594L9 17.156 20.204 5.954a1.127 1.127 0 0 1 1.594 1.594Z',
  viewBox: '0 0 24 24',
  glyph: 'CheckThick_Stroke2_Corner0_Rounded',
})
